import styled from 'styled-components';

export const CalcContainer = styled.div``;

export const CalcName = styled.h2`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 50px;
  line-height: 61px;
  text-align: center;

  color: #ffc300;

  margin-bottom: 80px;
`;

export const CalcType = styled.h3`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 32px;
  text-align: center;

  color: #fff;

  margin-bottom: 30px;
`;

export const CalcTypeCon = styled.div`
  margin-bottom: 80px;
`;

export const OverlayPictureG3 = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'L-образний 2') return '210px';
    return '158px';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'L-образний 2') return '72px';
    return '85px';
  }};
  width: ${({ selectedType }) => {
    if (selectedType === 'L-образний') return '170px';
    if (selectedType === 'L-образний 2') return '131px';
    return '85px';
  }};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const CalcTypeUl = styled.ul`
  list-style: none;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
`;


export const CalcWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  border: 2px solid #ffffff;
  width: 1026px;
  height: 610px;
  margin-bottom: 30px;

  background-color: #ffff;
`;

export const CalcWrapList = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 25px 75px;
  border: 2px solid #001d3d;
  width: 876px;
  height: 100%;
  margin-bottom: 50px;
  background-color: #ffff;
`;

export const OrderButton = styled.button`
  width: 218px;
  height: 31px;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  background-color: transparent;
  color: #001d3d;
  margin: 0 auto;
  border: 1px solid #001d3d;
`;

export const ListItemWrap = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
`;

export const ListParam = styled.p`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #001d3d;
  margin: 0 5px 0 0;
`;

export const ListParamText = styled.p`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  color: #001d3d;
  margin: 0;
`;

export const BoxWrap = styled.div`
  display: flex;
  flex-direction: row;
`;

export const TypeFastening = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CalcCardWrap = styled.div``;

export const CalcSettingsWrap = styled.div`
  width: 380px;
`;

export const CalcPicture = styled.div`
  width: 528px;
`;

export const TitleName = styled.div`
  text-align: center;
  position: relative; // Устанавливаем позицию для абсолютного позиционирования псевдоэлементов
  padding: 10px 0; // Добавляем отступ сверху и снизу
`;

export const TypeСurtains = styled.div`
  position: relative;
  display: inline-block;
  margin-bottom: 10px;

  &:hover .custom-arrow {
    background-color: #ffc300;
  }
`;

// Текстовый элемент
export const TitleSpan = styled.span`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: center;

  color: #001d3d;

  margin: 20px 0 20px 0;
`;

export const TitleList = styled.div`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #001d3d;
  margin: 0 0 20px 0;
`;

// Псевдоэлементы для полосок
export const TitleWrapper = styled.div`
  display: flex;
  align-items: center; // Вертикальное выравнивание
  justify-content: center; // Центрирование текста и полосок

  &::before,
  &::after {
    content: '';
    display: block;
    flex: 1; // Позволяет линиям растягиваться
    border-bottom: 1px solid #ccc; // Линия
    margin: 0 20px; // Отступы между линией и текстом
  }
`;

export const ImageContainer = styled.div`
  padding: 60px;

  position: relative;
  display: inline-block; /* Или block, в зависимости от контекста */
`;
export const ImageContainer2 = styled.div`
  position: absolute;
  display: none; /* Или block, в зависимости от контекста */
`;
// Стили для основной картинки
export const MainPicture = styled.img`
  width: 344px;
  display: block; /* Убирает возможные пробелы под изображением */
`;

export const Price = styled.span`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  color: #001d3d;
`;

// Стили для накладываемой картинки
export const OverlayPictureBelt = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '78px';
    if (selectedType === 'Трапеція 2') return '78px';
    if (selectedType === 'Трапеція 3') return '104px';
    if (selectedType === 'Трикутне (Стійки)') return '112px';
    if (selectedType === 'L-образний 2') return '64px';
    if (selectedType === 'Трикутне') return '142px';
    return '60px;';
  }};
  transform: ${({ selectedType }) => {
    if (selectedType === 'Трапеція 2') return 'scaleX(-1);';
    return 'scaleX(1);';
  }};
  left:  ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return '160px';
    if (selectedType === 'Трапеція 3') return '126px';
    return '130px;';
  }};
  width: ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return '170px';
    return '204px;';
  }};
  height: auto; /* Или конкретная высота, если нужно */
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;
export const MontageP = styled.p`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center; /* Центровка элементов по горизонтали */
  gap: 10px; /* Задаем расстояние между элементами */
  margin: 10px 0 10px 0;
`;
export const TotalPrice = styled.p`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center; /* Центровка элементов по горизонтали */
  gap: 10px; /* Задаем расстояние между элементами */
  margin: 20px 0 25px 0;
`;

export const PriceWithoutSale = styled.span`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 15px;
  display: flex;
  align-items: center;
  text-decoration: line-through;

  color: #9facd3;
`;

export const Sale = styled.p`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #fff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center; /* Центровка элементов по горизонтали */
  gap: 10px;
  margin: 0;
`;

export const SaleCount = styled.span`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  color: #fff;
`;

export const TotalWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DopText = styled.p`
  width: 820px;
  font-size: 14px;
  line-height: 1.3;
  color: #fff;
`;

export const OverlayPictureReflux = styled.div`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'T-образний') return '199px';
    if (selectedType === 'L-образний') return '213px';
     if (selectedType === 'L-образний 2') return '191px';
    if (selectedType === 'Трикутне (Стійки)') return '286px';
    if (selectedType === 'Трикутне') return '245px';
    if (selectedType === 'Трапеція 3') return '256px';
    return '260px;';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'T-образний') return '53px';
    if (selectedType === 'L-образний 2') return '52px';
    if (selectedType === 'L-образний') return '51px';
    return '43px;';
  }};
width:${({ selectedType }) => {
  if (selectedType === 'Трикутне') return '371px';
  return '361px;'}};
  height: auto; /* Или конкретная высота, если нужно */
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureSnakeLeft = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '132px';
    if (selectedType === 'Трикутне (Стійки)') return '140px';
    if (selectedType === 'Трикутне') return '175px';
    if (selectedType === 'Трапеція 2') return '80px';
    if (selectedType === 'Трапеція 3') return '130px';
    return '60px;';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'T-образний') return '170px';
    return '24%'}};
  height: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '150px';
    if (selectedType === 'Трикутне (Стійки)') return '160px';
    if (selectedType === 'Трикутне') return '100px';
    if (selectedType === 'T-образний') return '207px';
    if (selectedType === 'L-образний') return '150px';
    if (selectedType === 'Трапеція 2') return '200px';
    if (selectedType === 'L-образний 2') return '198px';
    if (selectedType === 'Трапеція 3') return '135px';
    return '207px;';
  }};

  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureSnakeCenter = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '106px';
    if (selectedType === 'Трапеція 2') return '106px';
    if (selectedType === 'Трикутне (Стійки)') return '88px';
    if (selectedType === 'Трапеція 3') return '64px';
    return '60px;';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'L-образний') return '56%';
    if (selectedType === 'L-образний 2') return '41%';
    return '49%;';
  }};
  height: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '175px';
    if (selectedType === 'Трапеція 2') return '175px';
    if (selectedType === 'Трикутне (Стійки)') return '213px';
    if (selectedType === 'L-образний') return '220px';
    if (selectedType === 'L-образний 2') return '198px';
    return '207px;';
  }};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureSnakeRight = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '80px';
    if (selectedType === 'Трапеція 2') return '132px';
    if (selectedType === 'Трапеція 3') return '130px';
    if (selectedType === 'Трикутне (Стійки)') return '140px';
    if (selectedType === 'Трикутне') return '175px';
    return '60px;';
  }};
  left: ${({ selectedType }) => { 
    if (selectedType === 'T-образний') return '286px';
    return '74%'}};
  height: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '200px';
     if (selectedType === 'Трапеція 2') return '150px';
     if (selectedType === 'Трапеція 3') return '135px';
    if (selectedType === 'Трикутне (Стійки)') return '160px';
    if (selectedType === 'L-образний') return '220px';
    if (selectedType === 'T-образний') return '207px';
    if (selectedType === 'Трикутне') return '100px';
    if (selectedType === 'L-образний 2') return '132px';
    return '207px;';
  }};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureTopScobLuv = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '89px';
    if (selectedType === 'Трапеція 2') return '89px';
    if (selectedType === 'Трапеція 3') return '53px';
    if (selectedType === 'L-образний 2') return '53px';
    if (selectedType === 'Трикутне (Стійки)') return '65px';
    return '51px';
  }};
  transform: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return 'rotate(-13deg)';
    if (selectedType === 'Трапеція 2') return 'rotate(13deg)';
    return 'rotate(0deg);';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '114px';
    if (selectedType === 'Трапеція 3') return '157px';
    return '80px';
  }};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureTopLuv = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '100px';
    if (selectedType === 'Трапеція 2') return '100px';
    if (selectedType === 'Трапеція 3') return '66px';
    if (selectedType === 'L-образний 2') return '66px';
    if (selectedType === 'Трикутне (Стійки)') return '88px';
    return '64px';
  }};
  transform: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return 'rotate(-13deg)';
    if (selectedType === 'Трапеція 2') return 'rotate(13deg)';

    return 'rotate(0deg);';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '116px';
    if (selectedType === 'Трапеція 3') return '165px';
    return '80px';
  }};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;



export const OverlayPictureTopPovScob = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '98px';
    if (selectedType === 'Трапеція 2') return '98px';
    if (selectedType === 'Трикутне (Стійки)') return '88px';
    if (selectedType === 'Трапеція 3') return '64px';
    return '63px';
  }};
  transform: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return 'rotate(-13deg)';
    if (selectedType === 'Трапеція 2') return 'rotate(13deg)';

    return 'rotate(0deg);';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '100px';
    if (selectedType === 'Трапеція 3') return '167px';
    return '65px';
  }};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureBottomScobLuv = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'L-образний') return '200px';
    if (selectedType === 'L-образний 2') return '181px';
    if (selectedType === 'T-образний') return '188px';
    if (selectedType === 'Трикутне (Стійки)') return '275px';
    if (selectedType === 'Трикутне') return '236px';
    if (selectedType === 'Трапеція 3') return '249px';
    return '251px'; // Стиль по умолчанию
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'L-образний') return '125px';
    if (selectedType === 'T-образний') return '85px';
    if (selectedType === 'L-образний 2') return '95px';
    return '80px'; // Стиль по умолчанию
  }};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureBottomLuv = styled.img`
  position: absolute;
  top: 264px;
  left: 80px;
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureBottomDovgRem = styled.img`
  position: absolute;
  top: 250px;
  left: 72px;
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureBottomPovScob = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'L-образний') return '198px';
    if (selectedType === 'L-образний 2') return '180px';
    if (selectedType === 'T-образний') return '185px';
    if (selectedType === 'Трикутне (Стійки)') return '270px';
    if (selectedType === 'Трикутне') return '235px';
    if (selectedType === 'Трапеція 3') return '247px';
    return '249px'; // Стиль по умолчанию
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'L-образний') return '100px';
    if (selectedType === 'L-образний 2') return '80px';
    if (selectedType === 'T-образний') return '82px';
    if (selectedType === 'Трикутне') return '80px';
    return '65px'; // Стиль по умолчанию
  }};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureBottomKarmPid = styled.div`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'L-образний') return '190px';
    if (selectedType === 'T-образний') return '175px';
    if (selectedType === 'Трикутне (Стійки)') return '254px';
    if (selectedType === 'Трапеція') return '228px';
    if (selectedType === 'L-образний 2') return '166px';
     if (selectedType === 'Трикутне') return '230px';
    return '218px'; // Стиль по умолчанию
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'L-образний') return '74px';
    if (selectedType === 'T-образний') return '70px';
    if (selectedType === 'Трикутне') return '73px';
    if (selectedType === 'L-образний 2') return '63px';
    return '60px'; // Стиль по умолчанию
  }};

  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureBottomArrow = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'L-образний') return '83px';
    if (selectedType === 'L-образний 2') return '78px';
    if (selectedType === 'T-образний') return '83px';
    if (selectedType === 'Комбінована') return '145px';
    if (selectedType === 'Комбінована 2') return '165px';
    if (selectedType === 'Трапеція') return '205px';
    if (selectedType === 'Трикутне (Стійки)') return '235px';
    if (selectedType === 'Трикутне') return '208px';
    return '200px'; // Стиль по умолчанию
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '73px';
    if (selectedType === 'Трикутне (Стійки)') return '86px';
    if (selectedType === 'Трикутне') return '90px';
    if (selectedType === 'L-образний') return '87px';
    if (selectedType === 'T-образний') return '87px';
    return '77px'; // Стиль по умолчанию
  }};
  width: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '317px';
    if (selectedType === 'Трикутне (Стійки)') return '292px';
    if (selectedType === 'L-образний') return '290px';
    if (selectedType === 'T-образний') return '290px';
    return '310px'; // Стиль по умолчанию
  }};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
  display: ${({ selectedType }) => {
    if (selectedType === 'Суцільна з ПВХ') return 'none';

    return 'block'; // Стиль по умолчанию
  }};
`;
export const OverlayPictureBottomArrowBig = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'L-образний') return '305px';
    if (selectedType === 'T-образний') return '305px';
    if (selectedType === 'Трикутне (Стійки)') return '305px';
    if (selectedType === 'Трикутне') return '268px';
    return '288px'; // Стиль по умолчанию
  }};
  left: 60px;
  width: ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return '370px';
    return '345px'; // Стиль по умолчанию
  }};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureRightArrow = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'L-образний') return '83px';
    if (selectedType === 'T-образний') return '85px';
    if (selectedType === 'Трикутне (Стійки)') return '96px';
    if (selectedType === 'L-образний 2') return '77px';
    if (selectedType === 'Комбінована 2') return '105px';
    return '74px'; // Стиль по умолчанию
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '200px';
    if (selectedType === 'Трикутне') return '214px';
    if (selectedType === 'T-образний') return '202px';
    if (selectedType === 'L-образний 2') return '70px';
    if (selectedType === 'Трапеція 2') return '70px';
     if (selectedType === 'Трапеція 3') return '196px';
    return '339px'; // Стиль по умолчанию
  }};
  height: ${({ selectedType }) => {
    if (selectedType === 'Комбінована') return '97px';
    if (selectedType === 'Комбінована 2') return '85px';
    if (selectedType === 'Трикутне (Стійки)') return '188px';
    if (selectedType === 'Трикутне') return '184px';
    if (selectedType === 'T-образний') return '194px';
    if (selectedType === 'L-образний') return '197px';
    if (selectedType === 'L-образний 2') return '178px';
    if (selectedType === 'Трапеція') return '185px';
    if (selectedType === 'Трапеція 2') return '185px';
    if (selectedType === 'Трапеція 3') return '182px';
    return '172px'; // Стиль по умолчанию
  }};
  width:59px;
  pointer-events: none;
  display: ${({ selectedType }) => {
    if (selectedType === 'Суцільна з ПВХ') return 'none';
    return 'block'; // Стиль по умолчанию
  }};
  z-index:9;
`;
export const OverlayPictureRightArrowBig = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return '60px';
    return '62px'; // Стиль по умолчанию
  }};
  left:  ${({ selectedType }) => {
    if (selectedType === 'Трапеція 2') return '0px';
    if (selectedType === 'L-образний 2') return '0px';
    return '412px'; // Стиль по умолчанию
  }};
  height: ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return '185px';
    if (selectedType === 'Трикутне (Стійки)') return '222px';
     if (selectedType === 'T-образний') return '220px';
     if (selectedType === 'L-образний') return '220px';
    return '197px'; // Стиль по умолчанию
  }};
  pointer-events: none;
`;

export const InputWrapperBottom = styled.div`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '206px';
    if (selectedType === 'L-образний') return '84px';
    if (selectedType === 'L-образний 2') return '84px';
    if (selectedType === 'T-образний') return '84px';
    if (selectedType === 'Трикутне (Стійки)') return '235px';
    if (selectedType === 'Трикутне') return '205px';
    if (selectedType === 'Комбінована') return '140px';
    if (selectedType === 'Комбінована 2') return '165px';
    return '198px'; // Стиль по умолчанию
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return '205px';
    return '197px'; // Стиль по умолчанию
  }};
  width: 80px; /* Увеличили ширину для размещения текста "мм" */
  height: 25px;
  z-index: 50;
  display: ${({ selectedType }) => {
    if (selectedType === 'Суцільна з ПВХ') return 'none';

    return 'block'; // Стиль по умолчанию
  }};
`;
export const InputWrapperBottomBig = styled.div`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'L-образний') return '309px';
    if (selectedType === 'T-образний') return '307px';
    if (selectedType === 'Трикутне (Стійки)') return '305px';
    if (selectedType === 'Трикутне') return '274px';
    return '290px'; // Стиль по умолчанию
  }};
  left: 197px;
  width: 80px; /* Увеличили ширину для размещения текста "мм" */
  height: 25px;
  z-index: 50;
`;
export const OverlayPictureBottomBigBar = styled.img`
  position: absolute;
  bottom: 60px;
  left: 39px;
  pointer-events: none;
`;
export const InputWrapperBottomBegBar = styled.div`
  position: absolute;
  bottom: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '57px';

    return '105px';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '0px';

    return '5px';
  }};
  width: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '45px';

    return '50px';
  }};
  height: 25px;
  z-index: 50;
`;

export const InputWrapperB = styled.div`
  position: absolute;
  bottom: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '113px';
    if (selectedType === 'Трапеція 2') return '120px';
    if (selectedType === 'T-образний') return '210px';
    if (selectedType === 'L-образний') return '185px';
    if (selectedType === 'L-образний 2') return '185px';
    if (selectedType === 'Трапеція 3') return '108px';
    if (selectedType === 'Трикутне (Стійки)') return '135px';
    return '115px';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '70px';
    if (selectedType === 'Трапеція 2') return '335px';
    if (selectedType === 'Трапеція 3') return '75px';
    if (selectedType === 'T-образний') return '86px';
    if (selectedType === 'L-образний') return '85px';
    if (selectedType === 'L-образний 2') return '335px';
    if (selectedType === 'Трикутне (Стійки)') return '90px';
    return '115px';
  }};
  width: 55px;
  height: 25px;
  z-index: 50;
`;

export const OverlayPictureB = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'T-образний') return '83px';
    if (selectedType === 'L-образний') return '83px';
    if (selectedType === 'L-образний 2') return '77px';
    if (selectedType === 'Трапеція 3') return '184px';
    if (selectedType === 'Трикутне (Стійки)') return '155px';
    return '144px';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'T-образний') return '82px';
    if (selectedType === 'L-образний') return '85px';
    if (selectedType === 'L-образний 2') return '370px';
    if (selectedType === 'Трапеція 2') return '370px';
    if (selectedType === 'Трикутне (Стійки)') return '86px';
    return '72px';
  }};
  height: ${({ selectedType }) => {
    if (selectedType === 'T-образний') return '115px';
    if (selectedType === 'Трапеція') return '115px';
    if (selectedType === 'Трапеція 2') return '115px';
    if (selectedType === 'L-образний') return '128px';
    if (selectedType === 'L-образний 2') return '115px';
    if (selectedType === 'Трикутне (Стійки)') return '130px';
    if (selectedType === 'Трапеція 3') return '72px';
    return '106px';
  }};
  z-index: 9;
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;
export const InputWrapperTrick = styled.div`
  position: absolute;
  bottom: ${({ selectedType }) => {
    if (selectedType === 'Трапеція 3') return '108px';
    return '135px';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'Трапеція 3') return '335px';
    return '320px';
  }};
  width: 55px;
  height: 25px;
  z-index: 50;
`;
export const OverlayPictureTrick = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція 3') return '184px';
    return '155px';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'Трапеція 3') return '380px';
    return '356px';
  }};
  height: ${({ selectedType }) => {
    if (selectedType === 'Трапеція 3') return '72px';
    return '130px';
  }};
  z-index: 9;
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const InputWrapperG = styled.div`
  position: absolute;
  bottom: ${({ selectedType }) => {
    if (selectedType === 'T-образний') return '97px';
    if (selectedType === 'L-образний') return '95px';
    if (selectedType === 'L-образний 2') return '150px';
    return '75px';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'T-образний') return '208px';
    if (selectedType === 'L-образний') return '295px';
    if (selectedType === 'L-образний 2') return '268px';
    return '115px';
  }};
  width: 55px;
  height: 25px;
  z-index: 50;
`;
export const OverlayPictureG = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'T-образний') return '220px';
    if (selectedType === 'L-образний') return '225px';
    if (selectedType === 'L-образний 2') return '145px';
    return '220px';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'T-образний') return '173px';
    if (selectedType === 'L-образний') return '260px';
    if (selectedType === 'L-образний 2') return '202px';
    return '173px';
  }};
  width: ${({ selectedType }) => {
    if (selectedType === 'L-образний 2') return '192px';
    return '118px';
  }};
  pointer-events: none; 
`;

export const InputWrapperG2 = styled.div`
  position: absolute;
  bottom: 175px;
  left: 310px;
  width: 55px;
  height: 25px;
  z-index: 50;
`;
export const InputWrapperG3 = styled.div`
  position: absolute;
  bottom: ${({ selectedType }) => {
    if (selectedType === 'L-образний') return '165px';
    if (selectedType === 'L-образний 2') return '90px';
    return '175px';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'L-образний') return '150px';
    return '102px';
  }};
  width: 55px;
  height: 25px;
  z-index: 50;
`;
export const OverlayPictureG2 = styled.img`
  position: absolute;
  top: 158px;
  left: 293px;
  width: 85px;
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureRefluxArrow = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'T-образний') return '177px';
    if (selectedType === 'L-образний') return '190px';
    if (selectedType === 'Трикутне (Стійки)') return '265px';
    if (selectedType === 'Трикутне') return '223px';
    return '238px';
  }};
  left: 21px;
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const InputWrapperReflux = styled.div`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'T-образний') return '160px';
    if (selectedType === 'L-образний') return '180px';
    if (selectedType === 'Трикутне (Стійки)') return '260px';
    if (selectedType === 'Трикутне') return '210px';
    return '225px';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'T-образний') return '0px';
    if (selectedType === 'L-образний') return '0px';
    if (selectedType === 'Трикутне (Стійки)') return '-10px';
    return '5px';
  }};
  width: 50px;
  height: 25px;
  z-index: 50;
`;

export const InputWrapperRight = styled.div`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Комбінована') return '115px';
    if (selectedType === 'Комбінована 2') return '141px';
    if (selectedType === 'Трикутне (Стійки)') return '175px';
    if (selectedType === 'Трикутне') return '155px';
    if (selectedType === 'L-образний') return '168px';
    if (selectedType === 'L-образний 2') return '155px';
    if (selectedType === 'T-образний') return '165px';
    if (selectedType === 'Трапеція 2') return '152px';
    if (selectedType === 'Трапеція') return '152px';
    return '148px';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '193px';
    if (selectedType === 'Трикутне') return '205px';
    if (selectedType === 'T-образний') return '198px';
    if (selectedType === 'L-образний 2') return '75px';
    if (selectedType === 'Трапеція 2') return '75px';
      if (selectedType === 'Трапеція 3') return '196px';
    return '308px';
  }};
  width: 80px;
  height: 25px;
  z-index: 50;
  display: ${({ selectedType }) => {
    if (selectedType === 'Суцільна з ПВХ') return 'none';
    return 'block';
  }};
`;
export const InputWrapperRightBig = styled.div`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return '140px';
    if (selectedType === 'Трикутне (Стійки)') return '160px';
    if (selectedType === 'T-образний') return '160px';
    if (selectedType === 'L-образний') return '160px';
    return '148px';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'L-образний 2') return '0px';
    if (selectedType === 'Трапеція 2') return '0px';
    return '410px';
  }};
  width: 60px; /* Увеличили ширину для размещения текста "мм" */
  height: 25px;
  z-index: 50;
`;

export const OverlayPictureBottomInput = styled.input`
  width: 100%;
  height: 100%;
  padding-right: 25px; /* Отступ для текста "мм" */
  box-sizing: border-box;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const OverlayPictureTopBar = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '113px';
    if (selectedType === 'Трикутне') return '48px';
    if (selectedType === 'Трикутне (Стійки)') return '118px';
    return '41px';
  }};
  left: ${({ selectedType }) => {
      if (selectedType === 'Трапеція 3') return '162px';
    if (selectedType === 'Трикутне') return '253px';
    return '60px';
  }};
  transform: ${({ selectedType }) => {
    if (selectedType === 'Трапеція 3') return 'rotate(-325deg);';
    if (selectedType === 'Трикутне') return 'rotate(50deg);';
    return 'rotate(0deg);';
  }};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureTopBarRight = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '118px';
    if (selectedType === 'Трапеція 2') return '110px';
    if (selectedType === 'Трикутне') return '48px';   
    return '41px';
  }};
  transform: ${({ selectedType }) => {
    if (selectedType === 'Трапеція 3') return 'rotate(325deg);';
    if (selectedType === 'Трикутне') return 'rotate(-50deg);';
    return 'rotate(0deg);';
  }};
  right: ${({ selectedType }) => {
     if (selectedType === 'Трапеція 3') return '172px';
    if (selectedType === 'Трикутне') return '253px';
    return '59px';
  }};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;
export const OverlayPictureTopBarGroupLeft = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '113px';
    if (selectedType === 'Трикутне (Стійки)') return '118px';
    return '-25px';
  }};
  left: -16px;
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const InputWrapperTop = styled.div`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '91px';
    if (selectedType === 'Трикутне') return '30px';
    if (selectedType === 'Трикутне (Стійки)') return '93px';
    return '20px';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'Трапеція 3') return '132px';
    if (selectedType === 'Трикутне') return '265px';
    return '60px';
  }};
  width: 50px;
  height: 25px;
  z-index: 50;
`;

export const InputWrapperTopRight = styled.div`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '93px';
    if (selectedType === 'Трикутне') return '30px';
     if (selectedType === 'Трапеція 2') return '90px';
    return '20px';
  }};
  right: ${({ selectedType }) => {
    if (selectedType === 'Трапеція 3') return '145px';
    if (selectedType === 'Трикутне') return '266px';
    return '60px';
  }};
  width: 50px;
  height: 25px;
  z-index: 50;
`;

export const InputWrapperTopFurnitur = styled.div`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '91px';
    if (selectedType === 'Трикутне (Стійки)') return '93px';
    return '0px';
  }};
  left: 5px;
  width: 50px;
  height: 25px;
  z-index: 50;
`;
export const OverlayPictureTopFurniturInput = styled.input`
  width: 100%;
  height: 100%;
  color:green;

  padding-right: 10px;
  box-sizing: border-box;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
export const InputWrapperLeftFurnitur = styled.div`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '91px';
    if (selectedType === 'Трикутне (Стійки)') return '93px';
    return '25px';
  }};
  left: 0px;
  width: 50px;
  height: 25px;
  z-index: 50;
`;

export const OverlayPictureLeftFurniturInput = styled.input`
  width: 100%;
  height: 100%;
  color:red;

  padding-right: 10px;
  box-sizing: border-box;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const OverlayPictureLeftBar = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '144px';
    if (selectedType === 'Трапеція 2') return '58px';
    if (selectedType === 'Трапеція 3') return '63px';
    if (selectedType === 'Трикутне (Стійки)') return '154px';
    return '60px';
  }};
  transform: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return 'rotate(-18deg)';
    if (selectedType === 'Трапеція 2') return 'rotate(10deg)';
    if (selectedType === 'Трикутне (Стійки)') return 'rotate(-25deg);';
    return 'rotate(0deg);';
  }};

  left: ${({ selectedType }) => {
    if (selectedType === 'Трапеція 3') return '125px';
    return '41px';
  }};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureRightBarDown = styled.img`
  position: absolute;
  bottom: ${({ selectedType }) => {
    if (selectedType === 'L-образний 2') return '66px';
    // if (selectedType === 'Трапеція') return '144px';
    // if (selectedType === 'Трапеція 2') return '58px';
    // if (selectedType === 'Трапеція 3') return '63px';
    // if (selectedType === 'Трикутне (Стійки)') return '154px';
    return '64px';
  }};

  right: ${({ selectedType }) => {
    if (selectedType === 'T-образний') return '125px';
     if (selectedType === 'L-образний 2') return '225px';
    return '41px';
  }};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureTopInput = styled.input`
  width: 100%;
  height: 100%;
  padding-right: 10px;
  box-sizing: border-box;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const InputWrapperTopLeft = styled.div`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '144px';
    if (selectedType === 'Комбінована 2') return '70px';
    if (selectedType === 'Трапеція 2') return '38px';
    if (selectedType === 'Трикутне (Стійки)') return '152px';
    return '60px';
  }};
  left: ${({ selectedType }) => {
    if (selectedType === 'Трапеція 3') return '80px';
    return '0px';
  }};
  width: 45px;
  height: 25px;
  z-index: 50;
`;

export const InputWrapperBottomRight = styled.div`
  position: absolute;
  bottom: ${({ selectedType }) => {
    if (selectedType === 'T-образний') return '64px';
    if (selectedType === 'L-образний') return '65px';
    if (selectedType === 'L-образний 2') return '64px';
    // if (selectedType === 'Трапеція 2') return '38px';
    // if (selectedType === 'Трикутне (Стійки)') return '152px';
    return '66px';
  }};
  right: ${({ selectedType }) => {
    if (selectedType === 'T-образний') return '80px';
    if (selectedType === 'L-образний 2') return '180px';
    return '0px';
  }};
  width: 45px;
  height: 25px;
  z-index: 50;
`;

export const RemoveButton = styled.div`
  position: absolute;
  top: 15px;
  right: 20px;
  background: none;
  border: none;
  color: black;
  font-size: 20px;
  cursor: pointer;
  margin-left: 10px;
  color: #001d3d;
`;

export const UnitLabel = styled.span`
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  font-size: 12px;
  color: #001d3d;
`;

export const OverlayPictureLeftNum = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '145px';
    if (selectedType === 'Трикутне (Стійки)') return '147px';
    if (selectedType === 'Трикутне') return '70px';
    if (selectedType === 'T-образний') return '70px';
    if (selectedType === 'L-образний') return '70px';
    return '79.5px';
  }};
  height: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '110px';
    if (selectedType === 'Трикутне (Стійки)') return '130px';
    if (selectedType === 'T-образний') return '120px';
    if (selectedType === 'L-образний') return '130px';
    return '163px';
  }};
  transform: ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return 'rotate(45deg);';
    return 'rotate(0deg);';}};
    left: ${({ selectedType }) => {
      if (selectedType === 'Трикутне') return '146px';
      return '56px';}};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureLeftScobLuv = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '145px';
    if (selectedType === 'Трапеція 3') return '80px';
    if (selectedType === 'Трикутне (Стійки)') return '147px';
    if (selectedType === 'Трикутне') return '70px';
    if (selectedType === 'T-образний') return '70px';
    if (selectedType === 'L-образний') return '70px';
    return '74px';
  }};
  height: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '110px';
    if (selectedType === 'Трикутне (Стійки)') return '130px';
    if (selectedType === 'T-образний') return '120px';
    if (selectedType === 'L-образний') return '130px';
    return '163px';
  }};
  transform: ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return 'rotate(45deg);';
    return 'rotate(0deg);';}};
  left: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '55px';
    if (selectedType === 'Трикутне (Стійки)') return '54px';
    if (selectedType === 'Трикутне') return '146px';
    return '52px';
  }};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureLeftLuv = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '145px';
    if (selectedType === 'Трапеція 3') return '78px';
    if (selectedType === 'Трикутне (Стійки)') return '147px';
    if (selectedType === 'T-образний') return '70px';
    if (selectedType === 'L-образний') return '70px';
    if (selectedType === 'Трикутне') return '70px';
    return '88px';
  }};
  height: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '110px';
    if (selectedType === 'Трикутне (Стійки)') return '130px';
    if (selectedType === 'T-образний') return '120px';
    if (selectedType === 'L-образний') return '120px';
    return '163px';
  }};
  transform: ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return 'rotate(45deg);';
    return 'rotate(0deg);';}};
    left: ${({ selectedType }) => {
      if (selectedType === 'Трикутне') return '159px';
      if (selectedType === 'Трапеція 3') return '63px';
      return '65px';}};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;
export const OverlayPictureLeftPovScob = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '145px';
    if (selectedType === 'Трапеція 3') return '85.5px';
    if (selectedType === 'Трикутне (Стійки)') return '147px';
    if (selectedType === 'T-образний') return '70px';
    if (selectedType === 'L-образний') return '70px';
    if (selectedType === 'Трикутне') return '70px';
    return '77.5px';
  }};
  height: ${({ selectedType }) => {
    if (selectedType === 'Трапеція') return '110px';
    if (selectedType === 'Трикутне (Стійки)') return '130px';
    if (selectedType === 'T-образний') return '120px';
    if (selectedType === 'L-образний') return '135px';
    return '163px';
  }};
  transform: ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return 'rotate(45deg);';
    return 'rotate(0deg);';}};
  left: ${({ selectedType }) => {
      if (selectedType === 'Трикутне') return '156px';
      if (selectedType === 'Трапеція 3') return '53px';
      return '63px';}};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureRightScobLuv = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '147px';
    if (selectedType === 'T-образний') return '70px';
    if (selectedType === 'Трикутне') return '70px';
    if (selectedType === 'Трапеція 2') return '142px';
    if (selectedType === 'L-образний 2') return '69px';
     if (selectedType === 'Трапеція 3') return '78px';
    return '74px';
  }};
  height: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '130px';
    if (selectedType === 'T-образний') return '120px';
    if (selectedType === 'Трапеція 2') return '110px';
    if (selectedType === 'L-образний 2') return '115px';
    return '163px';
  }};
  transform: ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return 'rotate(-45deg);';
    return 'rotate(0deg);';}};
    left: ${({ selectedType }) => {
      if (selectedType === 'Трикутне') return '326px';
      if (selectedType === 'Трапеція 2') return '396px';
      if (selectedType === 'L-образний 2') return '396px';
       if (selectedType === 'Трапеція 3') return '306px';
      return '394px';}};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureRightNum = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '147px';
    if (selectedType === 'T-образний') return '70px';
    if (selectedType === 'Трикутне') return '70px';
    if (selectedType === 'Трапеція 2') return '142.5px';
if (selectedType === 'L-образний 2') return '69px';
    return '79.5px';
  }};
  height: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '130px';
    if (selectedType === 'T-образний') return '120px';
    if (selectedType === 'Трапеція 2') return '110px';
if (selectedType === 'L-образний 2') return '115px';
    return '163px';
  }};
  transform: ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return 'rotate(-45deg);';
    return 'rotate(0deg);';}};
  left: ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return '330px';
    if (selectedType === 'Трапеція 2') return '400px';
    if (selectedType === 'Трапеція 3') return '310px';
if (selectedType === 'L-образний 2') return '400px';
    return '398px';}};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureRightLuv = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '147px';
    if (selectedType === 'T-образний') return '70px';
    if (selectedType === 'Трикутне') return '70px';
    if (selectedType === 'Трапеція 2') return '142px';
    if (selectedType === 'L-образний 2') return '69px';
    if (selectedType === 'Трапеція 3') return '76px';
    return '88px';
  }};
  height: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '130px';
    if (selectedType === 'T-образний') return '120px';
    if (selectedType === 'Трапеція 2') return '110px';
    if (selectedType === 'L-образний 2') return '115px';
    return '163px';
  }};
  transform: ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return 'rotate(-45deg);';
    return 'rotate(0deg);';}};
    left: ${({ selectedType }) => {
      if (selectedType === 'Трикутне') return '326px';
      if (selectedType === 'Трапеція 2') return '397px';
      if (selectedType === 'L-образний 2') return '396px';
      if (selectedType === 'Трапеція 3') return '302px';
      return '394px';}};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const OverlayPictureRightPovScob = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '147px';
    if (selectedType === 'T-образний') return '70px';
    if (selectedType === 'Трикутне') return '70px';
    if (selectedType === 'Трапеція 2') return '141.5px';
    if (selectedType === 'L-образний 2') return '69px';
    if (selectedType === 'Трапеція 3') return '85.5px';
    return '77.5px';
  }};
  height: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '130px';
    if (selectedType === 'T-образний') return '120px';
    if (selectedType === 'Трапеція 2') return '110px';
    if (selectedType === 'L-образний 2') return '115px';
    return '163px';
  }};
  transform: ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return 'rotate(-45deg);';
    return 'rotate(0deg);';}};
  left: ${({ selectedType }) => {
    if (selectedType === 'Трикутне') return '324px';
    if (selectedType === 'Трапеція 2') return '396px';
    if (selectedType === 'L-образний 2') return '395px';
    if (selectedType === 'Трапеція 3') return '307px';
    return '392px';}};
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;

export const FasteningParamsWrap = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-top: 10px;
  align-items: flex-end;
`;

export const FasteningTitle = styled.p`
  color: #313131;
  line-height: 1.3;
  font-family: 'Open Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-size: 14px;
  margin: 0%;
`;

export const FasteningButton = styled.button`
  width: 218px;
  height: 31px;
  margin: 0;
  background-color: transparent; // Основной цвет фона
  color: #001d3d;

  text-decoration: none;
  cursor: pointer;
  border: 1px solid #001d3d; // Убедитесь, что граница отсутствует
  transition: background-color 0.3s ease, box-shadow 0.3s ease; // Плавный переход для фона и тени
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;

  // &:hover {
  //   color: #fff;
  //   background-color: #fffff; // Голубоватый фон при наведении
  //   box-shadow: 0px 2px 0px rgba(255, 255, 255, 0.35); // Увеличиваем тень при наведении
  // }

  &:focus {
    outline: none; // Удаляем стандартный фокусный бордер
  }
`;

export const FasteningSelect = styled.select`
  width: 190px;
  height: 24px;
  outline: none;
  appearance: none;
  padding-left: 5px;
  border: none;

  background-color: transparent;
  color: #001d3d;
  border: 1px solid #001d3d;

  & > option {
    background-color: ffffff;
    color: #001d3d;
    padding: 5px;
  }
`;

export const Fasteningwrap = styled.div`
  width: 190px;
  height: 25px;
  border: 1px solid #001d3d;
  position: relative;
  &:hover .IconContainer {
    background-color: #ffc300;
  }
`;
export const FasteningIconContainer = styled.div`
  background-color: transparent;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  top: 0;
  pointer-events: none; /* Позволяет клики по select элементу */
  user-select: none; /* Отключаем выделение текста */
  transition: background-color 0.3s ease; /* Плавный переход для фона */
`;
export const FasteningParamsItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FilmWrap = styled.div``;

export const NumberCurtainsWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
`;

export const TextileSelect = styled.select`
  width: 380px;
  height: 25px;
  margin-bottom: 6px;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  display: flex;
  align-items: center;
  color: #001d3d;
  padding-right: 30px; /* Оставляем место для кастомного плюсика */
  padding-left: 5px;
  border: 1px solid #ccc;
  background: transparent;
  appearance: none; /* Убираем стандартную стрелку */
  outline: none;
  box-shadow: none;
  border: 1px solid #001d3d;
  
  margin-bottom: 5px;

  & > option {
    background-color: rgb(255, 255, 255);
    color: #001d3d;
    padding: 5px;
  }
`;

export const CustomArrow = styled.div`
  position: absolute;
  text-align: center;
  width: 32px;
  height: 23px;
  background-color: transparent;
  top: 21px;
  right: 1px;
  font-size: 22px;
  color: #001d3d;
  pointer-events: none; /* Позволяет клики по select элементу */
  user-select: none; /* Отключаем выделение текста */
  transition: background-color 0.3s ease; /* Плавный переход для фона */
`;

export const Plus = styled.p`
  margin-top: -3px;
`;

export const ParamСurtains = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const ParamСurtainsTitle = styled.p`
  margin: 0;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  display: flex;
  align-items: center;
  color: #707070;
`;

export const ParamСurtainsSpan = styled.span`
  margin: 0;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  display: flex;
  align-items: center;
  color: #000;
`;

export const ColorSelect = styled.select`
  border: none;
  outline: none;
  font-size: 16px;
  width: 223px;
  height: 25px;
  appearance: none;
  padding-left: 5px;
`;
export const ColorCont = styled.div`
  width: 223px;
  height: 25px;
  border: 1px solid #001d3d;
  display: flex;
  position: relative;
`;
export const IconContainer = styled.div`
  background-color: transparent;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  pointer-events: none; /* Позволяет клики по select элементу */
  user-select: none; /* Отключаем выделение текста */
  transition: background-color 0.3s ease; /* Плавный переход для фона */
`;

export const IconButton = styled.p`
  background: none;
  border: none;
  color: #000;
  font-size: 20px;
  width: 13px;
  height: 26px;
  cursor: pointer;
  margin: 0;
  &:focus {
    outline: none;
  }
`;

export const NumberSelectDiv = styled.div`
  width: 223px;
  height: 25px;
  border: 1px solid #001d3d;

  color: #ffffff;
`;

export const NumberInput = styled.input`
  width: 190px;
  height: 25px;
  padding: 0;
  border: none;
  margin-right: 5px;
  padding-left: 3px;
  &:focus {
    outline: none;
    border: none;
  }
`;

export const NumSaleDiv = styled.div`
  display: flex;
  align-items: center;
  width: 150px;
  height: 25px;
  border: 1px solid #001d3d;
`;

export const NumSaleInput = styled.input`
  width: 190px;
  height: 25px;
  padding: 0;
  border: none;
  padding-left: 3px;
  &:focus {
    outline: none;
    border: none;
  }
  /* Ограничить ввод только числами */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const PercentageSign = styled.span`
  font-size: 16px;
  color: #001d3d;
  margin-left: 5px;
  margin-right: 5px;
`;

export const ColorWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  &:hover .IconContainer {
    background-color: #ffc300;
  }
`;

export const BeltWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const SnakeWrap = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;
export const ZipWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;

`;
export const InstallationWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;

export const MainPictureSubTitle = styled.p`
  text-align: left;
  font-size: 12px;
  padding: 10px 20px;
  color: #999;
`;

export const RefluxWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;
export const SaleWrap = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SnakeLabelWrap = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h4`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #001d3d;
  margin: 0;
`;

export const SubTitle = styled.h6`
  margin: 0;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 9px;
  line-height: 11px;
  color: #707070;
  margin-bottom: 12px;
`;

export const ChooseDiv = styled.div`
  padding: 20px;
  text-align: center;
  background-color: ${props =>
    props.selected ? 'white' : 'white'}; // Фон при выборе белый
  /* box-shadow: ${props =>
    props.selected
      ? '0px 4px 8px rgba(0, 0, 0, 0.2)'
      : 'none'}; // Тень при выборе */

  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  box-sizing: border-box; // Убедитесь, что границы не влияют на размеры
  border: ${props =>
    props.selected ? '1px solid #FFC300' : '1px solid transparent'};
  // Эффект наведения
  &:hover {
    background-color: #f0f0f0; // Фон при наведении
  }
`;

export const ChoosePhoto = styled.img`
  width: 120px;
  height: 70px;
  object-fit: cover; // Чтобы изображение не растягивалось
  margin-bottom: 15px;
`;

export const ChooseText = styled.p`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: left;
  color: #001d3d;
  margin: 0;
`;

export const SwitcherWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 160px;
  height: 25px;
  border: 1px solid #000;
  overflow: hidden;
`;

export const SwitcherWrapperSmall = styled.div`
  display: flex;
  align-items: center;
  width: 100px;
  height: 25px;
  border: 1px solid #000;
  overflow: hidden;
`;

// Стили для каждой кнопки
export const SwitcherButton = styled.button`
  flex: 1;
  padding: 8px;
  font-size: 16px;
  background-color: ${props =>
    props.active ? '#fbc02d' : '#fff'}; /* Желтый цвет активной кнопки */
  color: ${props =>
    props.active
      ? '#000'
      : '#333'}; /* Цвет текста в зависимости от состояния */
  border: none;
  cursor: pointer;
  outline: none;

  &:hover {
    background-color: ${props =>
      props.active
        ? '#fbc02d'
        : '#f0f0f0'}; /* Hover эффект для неактивной кнопки */
  }
`;

export const SwitcherWrapperSnake = styled.div`
  display: flex;
  align-items: center;
  width: 296px;
  height: 25px;
  border: 1px solid #000;
  overflow: hidden;
`;
export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

 export const Modal = styled.div`
  background: white;
  padding: 20px;
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 10px;
  min-width: 400px;
`;

export const Wrap = styled.div`
  margin-bottom: 10px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
`;
export const OverlayPictureRightDovgRem = styled.img`
  position: absolute;
  top: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '147px';
    if (selectedType === 'T-образний') return '70px';
    return '77.5px';
  }};
  height: ${({ selectedType }) => {
    if (selectedType === 'Трикутне (Стійки)') return '130px';
    if (selectedType === 'T-образний') return '120px';
    return '163px';
  }};
  left: 394px;
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;
export const OverlayPictureLeftDovgRem = styled.img`
  position: absolute;
  top: 77.5px;
  left: 63px;
  pointer-events: none; /* Позволяет клики пройти сквозь изображение */
`;